import React from 'react';
import './InfoPage.css';

const Legal: React.FC = () => {
  return (
    <div className="info-page">
      <div className="info-page-container">
        <h1>Legal</h1>
        <p>
          Deferredly is an educational guidance platform. Content and estimates are informational only and are not
          guarantees of admissions outcomes.
        </p>
        <p>
          By using Deferredly, users agree to provide accurate information and to use the platform in compliance with
          applicable laws and school policies.
        </p>
        <p>
          Questions about terms or permitted use can be sent to{' '}
          <a href="mailto:legal@deferredly.com">legal@deferredly.com</a>.
        </p>
      </div>
    </div>
  );
};

export default Legal;
